import { MODEL_UI } from '../copy/model-configuration'
import { Bot, Database, SlidersHorizontal } from 'lucide-react'
import type { MouseEvent } from 'react'

import './skills/skills.css'

import { cn } from '../components/cn'

const items = [
  { href: '/skills', label: 'Agent', hint: MODEL_UI.ui_001, icon: Bot },
  {
    href: '/system-models',
    label: MODEL_UI.ui_002,
    hint: MODEL_UI.ui_003,
    icon: SlidersHorizontal,
  },
  { href: '/models', label: MODEL_UI.ui_004, hint: MODEL_UI.ui_005, icon: Database },
] as const

export function AITeamNav({ current }: { current: (typeof items)[number]['href'] }) {
  return (
    <nav
      aria-label={MODEL_UI.ui_006}
      className="mb-npc-grid-lg grid grid-cols-3 border-b border-npc-border max-[600px]:grid-cols-1 max-[600px]:border-b-0"
    >
      {items.map(({ href, label, hint, icon: Icon }) => (
        <a
          key={href}
          href={href}
          onClick={(event) => navigateWithoutReload(event, href)}
          aria-current={current === href ? 'page' : undefined}
          className={cn(
            'flex min-w-0 items-center gap-npc-gap-sm border-b-2 px-npc-grid-sm py-npc-grid-sm text-npc-ink-soft transition-colors',
            'max-[600px]:border-b max-[600px]:border-l-2 max-[600px]:border-r-0 max-[600px]:border-t-0',
            current === href
              ? 'border-npc-green text-npc-ink'
              : 'border-transparent hover:border-npc-border-hover hover:text-npc-ink',
          )}
        >
          <Icon size={17} aria-hidden="true" className="shrink-0" />
          <span className="min-w-0">
            <span className="block text-npc-caption font-semibold">{label}</span>
            <span className="block truncate text-npc-meta">{hint}</span>
          </span>
        </a>
      ))}
    </nav>
  )
}

function navigateWithoutReload(event: MouseEvent<HTMLAnchorElement>, href: string) {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  )
    return
  event.preventDefault()
  window.history.pushState({}, '', href)
  window.dispatchEvent(new PopStateEvent('popstate'))
}
